import { render, staticRenderFns } from "./aresGPT.vue?vue&type=template&id=57cec896"
import script from "./aresGPT.vue?vue&type=script&lang=js"
export * from "./aresGPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports